import { useEffect } from "react";

export default function ConfirmDialog({ title, description, confirmLabel, confirmColor, onConfirm, onCancel }: {
  title: string;
  description: string;
  confirmLabel: string;
  confirmColor: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onCancel]);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50" onClick={onCancel}>
      <div className="bg-white rounded-2xl shadow-elevated p-6 max-w-sm w-full mx-4" onClick={e => e.stopPropagation()}>
        <h3 className="text-[15px] font-semibold text-ink-900 mb-2">{title}</h3>
        <p className="text-[13px] text-ink-500 mb-8 leading-relaxed">{description}</p>
        <div className="flex gap-3">
          <button onClick={onConfirm}
            className={`flex-1 py-2.5 rounded-xl text-[13px] font-medium text-white transition-all ${confirmColor}`}>
            {confirmLabel}
          </button>
          <button onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl text-[13px] font-medium bg-white border border-surface-200 text-ink-700 hover:bg-surface-50 transition-all">
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
}
